<div class="flex items-center justify-between">
  <h3 class="flex items-center gap-3 text-lg font-bold">Add signature</h3>
  <button class="self-start" mat-dialog-close>
    <img src="assets/icons/close.svg" alt="Close" width="16" height="16" />
  </button>
</div>

<signature-pad
  [options]="signaturePadOptions"
  class="!bg-white"
></signature-pad>

@if(error()){
<p class="text-error text-right">{{ error() }}</p>
}

<div class="flex items-center gap-4">
  <button
    [disabled]="isLoading()"
    class="btn btn-sm btn-outline min-w-[120px] rounded-full normal-case"
    (click)="onClear()"
  >
    Clear
  </button>
  <div class="flex-grow"></div>
  <button
    [disabled]="isLoading()"
    class="btn btn-sm btn-outline min-w-[120px] rounded-full normal-case"
    mat-dialog-close
  >
    Cancel
  </button>
  <button
    class="btn btn-sm btn-primary min-w-[120px] rounded-full normal-case"
    (click)="onSave()"
  >
    @if(isLoading()) {
    <et-atoms-spinner size="small"></et-atoms-spinner>
    } @else { Save }
  </button>
</div>
